export class InputError extends Error {}
